var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        attrs: { "data-vv-scope": "step-1-part-1", autocomplete: "off" },
        on: {
          submit: function($event) {
            $event.preventDefault()
          }
        }
      },
      [
        _c("div", { staticClass: "row mt-1 d-flex align-items-end" }, [
          _vm._m(0),
          _c(
            "div",
            { staticClass: "col-12 d-flex align-items-center mt-5" },
            [
              _c("h6", [_vm._v("Remitente:")]),
              _c(
                "b-form-group",
                [
                  _c(
                    "b-form-radio-group",
                    {
                      attrs: {
                        id: "sender-types",
                        name: "sender-type",
                        disabled: _vm.isBlocked
                      },
                      model: {
                        value: _vm.step.sender,
                        callback: function($$v) {
                          _vm.$set(_vm.step, "sender", $$v)
                        },
                        expression: "step.sender"
                      }
                    },
                    [
                      _c(
                        "b-form-radio",
                        {
                          staticClass: "ml-3 mr-5",
                          attrs: { value: "CIU", "data-cy": "check-citizen" },
                          on: {
                            change: function($event) {
                              return _vm.clearSender()
                            }
                          }
                        },
                        [_vm._v(" Ciudadano/a ")]
                      ),
                      _c(
                        "b-form-radio",
                        {
                          staticClass: "ml-3 mr-5",
                          attrs: {
                            value: "PROV",
                            "data-cy": "health-provider"
                          },
                          on: {
                            change: function($event) {
                              return _vm.clearSender()
                            }
                          }
                        },
                        [_vm._v(" Proveedores ")]
                      ),
                      _c(
                        "b-form-radio",
                        {
                          staticClass: "mr-5",
                          attrs: {
                            value: "PJU",
                            "data-cy": "check-legal-entity"
                          },
                          on: {
                            change: function($event) {
                              return _vm.clearSender()
                            }
                          }
                        },
                        [_vm._v(" Persona Jurídica ")]
                      ),
                      _c(
                        "b-form-radio",
                        {
                          staticClass: "mr-5",
                          attrs: {
                            value: "OES",
                            "data-cy": "check-state-agency"
                          },
                          on: {
                            change: function($event) {
                              return _vm.clearSender()
                            }
                          }
                        },
                        [_vm._v(" Organismo del estado ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mt-3" }, [
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c("vs-input-rut", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: {
                      required: _vm.step.sender === "CIU",
                      validateRut: true
                    },
                    expression:
                      "{'required':step.sender === 'CIU',validateRut:true}"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  label:
                    _vm.step.sender === "CIU"
                      ? "Rut Emisor *"
                      : "Rut remitente",
                  placeholder: "12345678-0",
                  autocomplete: "off",
                  name: "senderIut",
                  "data-as": "rut",
                  "data-vv-as": "rut",
                  danger: _vm.errors.has("step-1-part-1.senderIut"),
                  "danger-text": _vm.errors.first("step-1-part-1.senderIut")
                },
                model: {
                  value: _vm.step.senderIut,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "senderIut", $$v)
                  },
                  expression: "step.senderIut"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|max:200",
                    expression: "'required|max:200'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  autocomplete: "off",
                  label:
                    _vm.step.sender === "CIU"
                      ? "Nombre *"
                      : "Nombre remitente *",
                  "data-vv-as": "nombre",
                  name: "senderName",
                  danger: _vm.errors.has("step-1-part-1.senderName"),
                  "danger-text": _vm.errors.first("step-1-part-1.senderName")
                },
                model: {
                  value: _vm.step.senderName,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "senderName", $$v)
                  },
                  expression: "step.senderName"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mt-3" }, [
          _vm.step.sender === "PROV" || _vm.step.sender === "PJU"
            ? _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c("vs-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: { validateRut: true },
                        expression: "{ validateRut: true }"
                      }
                    ],
                    staticClass: "w-100",
                    attrs: {
                      autocomplete: "off",
                      label: _vm.iutLabel,
                      "data-vv-as": _vm.iutLabel.toLowerCase(),
                      name: "senderCompanyIut",
                      danger: _vm.errors.has("step-1-part-1.senderCompanyIut"),
                      "danger-text": _vm.errors.first(
                        "step-1-part-1.senderCompanyIut"
                      )
                    },
                    model: {
                      value: _vm.step.senderCompanyIut,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "senderCompanyIut", $$v)
                      },
                      expression: "step.senderCompanyIut"
                    }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm.step.sender === "PJU" ||
          _vm.step.sender === "OES" ||
          _vm.step.sender === "PROV"
            ? _c(
                "div",
                { staticClass: "col-6" },
                [
                  _c("vs-input", {
                    directives: [
                      {
                        name: "validate",
                        rawName: "v-validate",
                        value: {
                          required: _vm.nameIsRequired,
                          max: "200"
                        },
                        expression:
                          "{\n          required: nameIsRequired,\n          max: '200'\n        }"
                      }
                    ],
                    staticClass: "w-100",
                    attrs: {
                      autocomplete: "off",
                      label: _vm.nameLabel,
                      "data-vv-as": _vm.nameLabel
                        .replace("*", "")
                        .toLowerCase(),
                      name: "senderCompanyName",
                      danger: _vm.errors.has("step-1-part-1.senderCompanyName"),
                      "danger-text": _vm.errors.first(
                        "step-1-part-1.senderCompanyName"
                      )
                    },
                    model: {
                      value: _vm.step.senderCompanyName,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "senderCompanyName", $$v)
                      },
                      expression: "step.senderCompanyName"
                    }
                  })
                ],
                1
              )
            : _vm._e()
        ]),
        _c("div", { staticClass: "row mt-3" }, [
          _c("div", { staticClass: "col-6 d-flex align-items-end" }, [
            _c(
              "div",
              { staticClass: "w-100" },
              [
                _c("ListCommunes", {
                  attrs: {
                    label: "Comunas",
                    autocomplete: "off",
                    "data-vv-as": "comuna",
                    name: "senderComune",
                    isClearable: false,
                    clearCommune: _vm.clearCommune,
                    danger: _vm.errors.has("step-1-part-1.senderComune"),
                    "danger-text": _vm.errors.first(
                      "step-1-part-1.senderComune"
                    ),
                    state: _vm.errors.has("step-1-part-1.senderComune")
                      ? false
                      : null
                  },
                  model: {
                    value: _vm.step.senderComune,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "senderComune", $$v)
                    },
                    expression: "step.senderComune"
                  }
                })
              ],
              1
            )
          ]),
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c("vs-input", {
                staticClass: "w-100",
                attrs: {
                  autocomplete: "off",
                  label: "Dirección",
                  "data-vv-as": "dirección",
                  name: "senderAddress"
                },
                model: {
                  value: _vm.step.senderAddress,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "senderAddress", $$v)
                  },
                  expression: "step.senderAddress"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mt-3" }, [
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c("vs-input", {
                staticClass: "w-100",
                attrs: {
                  autocomplete: "off",
                  label: "Correo electrónico",
                  "data-vv-as": "correo electrónico",
                  name: "senderEmail",
                  danger: _vm.errors.has("step-1-part-1.senderEmail"),
                  "danger-text": _vm.errors.first("step-1-part-1.senderEmail")
                },
                model: {
                  value: _vm.step.senderEmail,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "senderEmail", $$v)
                  },
                  expression: "step.senderEmail"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { regex: _vm.phoneRegex },
                    expression: "{ regex: phoneRegex }"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  autocomplete: "off",
                  label: "Teléfono",
                  placeholder: "Escriba en formato +56912345678",
                  "data-vv-as": "teléfono",
                  name: "senderPhone",
                  danger: _vm.errors.has("step-1-part-1.senderPhone"),
                  "danger-text": _vm.errors.first("step-1-part-1.senderPhone")
                },
                model: {
                  value: _vm.step.senderPhone,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "senderPhone", $$v)
                  },
                  expression: "step.senderPhone"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mb-3 mt-3" }, [
          _vm._m(1),
          _c(
            "div",
            { staticClass: "col-md-6 mt-3" },
            [
              _c("vs-input", {
                staticClass: "w-100",
                attrs: {
                  label: "Código Documento",
                  name: "documentCode",
                  "data-cy": "document-code",
                  disabled: ""
                },
                model: {
                  value: _vm.previewCode,
                  callback: function($$v) {
                    _vm.previewCode = $$v
                  },
                  expression: "previewCode"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-6 mt-3" },
            [
              _c("label", [_vm._v("Fecha de ingreso *")]),
              _c("date-picker", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  "data-cy": "date-of-admission",
                  name: "issueDate",
                  format: "YYYY-MM-DD",
                  "value-type": "YYYY-MM-DD",
                  "data-vv-as": "fecha de ingreso",
                  danger: _vm.errors.has("step-1-part-1.issueDate"),
                  "danger-text": _vm.errors.first("step-1-part-1.issueDate")
                },
                model: {
                  value: _vm.step.issueDate,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "issueDate", $$v)
                  },
                  expression: "step.issueDate"
                }
              }),
              _vm.errors.has("step-1-part-1.issueDate")
                ? _c("div", [
                    _c("small", { staticClass: "text-danger" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm.errors.first("step-1-part-1.issueDate")) +
                          " "
                      )
                    ])
                  ])
                : _vm._e()
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-6 mt-3" },
            [
              _c("list-document-types-externals", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                ref: "documentTypes",
                staticClass: "w-100",
                attrs: {
                  autocomplete: "",
                  label: "Tipo Documento *",
                  name: "documentType",
                  "data-cy": "document-type",
                  danger: _vm.errors.has("step-1-part-1.documentType"),
                  "danger-text": _vm.errors.first("step-1-part-1.documentType")
                },
                on: { change: _vm.updateNumeration },
                model: {
                  value: _vm.step.documentType,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "documentType", $$v)
                  },
                  expression: "step.documentType"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-6 mt-3" },
            [
              _c("vs-input", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  label: "Nº Documento *",
                  name: "documentNumber",
                  "data-cy": "document-number",
                  "data-vv-as": "nº documento",
                  danger: _vm.errors.has("step-1-part-1.documentNumber"),
                  "danger-text": _vm.errors.first(
                    "step-1-part-1.documentNumber"
                  )
                },
                model: {
                  value: _vm.step.documentNumber,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "documentNumber", $$v)
                  },
                  expression: "step.documentNumber"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-6 mt-3" },
            [
              _c("ListProcess", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: true },
                    expression: "{ required: true }"
                  }
                ],
                ref: "process",
                staticClass: "w-100",
                attrs: {
                  group: "ed-exp-processos",
                  autocomplete: "",
                  label: "Proceso (*)",
                  placeholder: "Seleccione...",
                  name: "process",
                  "data-cy": "process",
                  "data-vv-as": "proceso",
                  danger: _vm.errors.has("step-1.process"),
                  "danger-text": _vm.errors.first("step-1.process")
                },
                on: {
                  "get-option-id": _vm.getOptionId,
                  change: _vm.updateNumeration
                },
                model: {
                  value: _vm.step.process,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "process", $$v)
                  },
                  expression: "step.process"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-6 mt-3" },
            [
              _c("ListSubProcess", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: { required: true },
                    expression: "{ required: true }"
                  }
                ],
                ref: "subProcess",
                staticClass: "w-100",
                attrs: {
                  group: "ed-exp-processos",
                  autocomplete: "",
                  label: "Subproceso (*)",
                  name: "subProcess",
                  "data-cy": "sub-process",
                  "parent-value": _vm.processId,
                  "data-vv-as": "subproceso",
                  danger: _vm.errors.has("step-1.subProcess"),
                  "danger-text": _vm.errors.first("step-1.subProcess")
                },
                on: { change: _vm.updateNumeration },
                model: {
                  value: _vm.step.subProcess,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "subProcess", $$v)
                  },
                  expression: "step.subProcess"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-12 mt-3" },
            [
              _c("label", [_vm._v("Materia *")]),
              _c("vs-textarea", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required|min:3",
                    expression: "'required|min:3'"
                  }
                ],
                staticClass: "mb-0",
                attrs: {
                  type: "text",
                  id: "matter",
                  label: "Materia (Mínimo 2 palabras, máximo 5000 caracteres)",
                  name: "matter",
                  width: "100%",
                  height: "100px",
                  maxlength: "5000"
                },
                model: {
                  value: _vm.step.matter,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "matter", $$v)
                  },
                  expression: "step.matter"
                }
              }),
              _vm.errors.first("step-1-part-1.matter")
                ? _c(
                    "div",
                    {
                      staticClass:
                        "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to",
                      staticStyle: { height: "32px" }
                    },
                    [
                      _c("span", { staticClass: "span-text-validation" }, [
                        _vm._v(
                          " " +
                            _vm._s(_vm.errors.first("step-1-part-1.matter")) +
                            " "
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ],
            1
          )
        ]),
        _vm._m(2)
      ]
    ),
    _c(
      "form",
      { attrs: { "data-vv-scope": "step-1-part-2" } },
      [
        _c("SelectSubjectGore", {
          attrs: { scope: "step-1-part-2" },
          on: { "add-subject": _vm.addSubject }
        }),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _vm.step.subjects
                ? _c("TableSubjects", {
                    attrs: { subjects: _vm.step.subjects },
                    model: {
                      value: _vm.step.subjectsSelected,
                      callback: function($$v) {
                        _vm.$set(_vm.step, "subjectsSelected", $$v)
                      },
                      expression: "step.subjectsSelected"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ],
      1
    ),
    _c(
      "form",
      { attrs: { "data-vv-scope": "step-1-part-4" } },
      [
        _vm._m(3),
        _c("div", { staticClass: "row mb-3" }, [
          _vm._m(4),
          _c(
            "div",
            { staticClass: "col-md-3 d-flex align-items-end" },
            [
              _c("UploadFileAdvanced", {
                attrs: {
                  permission: "*",
                  text: "Seleccionar archivo",
                  accept: ".pdf,.rar,.zip,",
                  "max-size-in-mb": 30,
                  "upload-to": "ed",
                  "button-class": "btn-block",
                  "container-class": "w-100"
                },
                model: {
                  value: _vm.step.mainFile,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "mainFile", $$v)
                  },
                  expression: "step.mainFile"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-3 align-items-end" },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "has-permission",
                      rawName: "v-has-permission",
                      value: "ED060",
                      expression: "'ED060'"
                    },
                    {
                      name: "b-modal",
                      rawName: "v-b-modal",
                      value: "add-file-repository",
                      expression: "'add-file-repository'"
                    }
                  ],
                  staticClass: "btn-icon mt-1",
                  attrs: { variant: "secondary", "data-cy": "from-repository" }
                },
                [
                  _c("feather-icon", { attrs: { icon: "ServerIcon" } }),
                  _vm._v(" Desde el repositorio ")
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mb-3" }, [
          _vm._m(5),
          _c(
            "div",
            { staticClass: "col-md-3 d-flex align-items-end" },
            [
              _c("UploadFileAdvanced", {
                attrs: {
                  permission: "*",
                  text: "Seleccionar archivo",
                  accept: ".pdf,.rar,.zip,",
                  "max-size-in-mb": 30,
                  "upload-to": "ed",
                  "button-class": "btn-block",
                  "container-class": "w-100"
                },
                on: {
                  input: function($event) {
                    return _vm.addAdditionalFile()
                  }
                },
                model: {
                  value: _vm.additionalFile,
                  callback: function($$v) {
                    _vm.additionalFile = $$v
                  },
                  expression: "additionalFile"
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-3 align-items-end" },
            [
              _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "has-permission",
                      rawName: "v-has-permission",
                      value: "ED060",
                      expression: "'ED060'"
                    },
                    {
                      name: "b-modal",
                      rawName: "v-b-modal",
                      value: "add-file-repository",
                      expression: "'add-file-repository'"
                    }
                  ],
                  staticClass: "btn-icon mt-1",
                  attrs: { variant: "secondary", "data-cy": "from-repository" }
                },
                [
                  _c("feather-icon", { attrs: { icon: "ServerIcon" } }),
                  _vm._v(" Desde el repositorio ")
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm.step.mainFile.name || _vm.step.additionalFiles.length
          ? _c("div", { staticClass: "row mb-3" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _c(
                    "b-table-simple",
                    { attrs: { hover: "", small: "" } },
                    [
                      _c(
                        "b-thead",
                        [
                          _c(
                            "b-tr",
                            [
                              _c("b-th", { attrs: { scope: "col" } }, [
                                _vm._v("Nombre archivo")
                              ]),
                              _c("b-th", { attrs: { scope: "col" } }, [
                                _vm._v("Nombre documento")
                              ]),
                              _c("b-th", { attrs: { scope: "col" } }, [
                                _vm._v("Formato")
                              ]),
                              _c("b-th", { attrs: { scope: "col" } }, [
                                _vm._v("-")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.step.mainFile.name
                        ? _c(
                            "b-tbody",
                            [
                              _c(
                                "b-tr",
                                [
                                  _c("b-td", [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: "Principal",
                                            expression: "'Principal'"
                                          }
                                        ],
                                        staticClass: "d-flex align-items-center"
                                      },
                                      [
                                        _c("vs-icon", {
                                          staticClass: "mr-1",
                                          attrs: {
                                            icon: "file_present",
                                            size: "medium"
                                          }
                                        }),
                                        _vm._v(
                                          " " +
                                            _vm._s(_vm.step.mainFile.name) +
                                            " "
                                        )
                                      ],
                                      1
                                    )
                                  ]),
                                  _c(
                                    "b-td",
                                    [
                                      _c("vs-input", {
                                        staticClass: "w-100",
                                        model: {
                                          value:
                                            _vm.step.mainFile
                                              .currentDescription,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.step.mainFile,
                                              "currentDescription",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "step.mainFile.currentDescription"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-td",
                                    [
                                      _c("b-form-select", {
                                        attrs: { options: _vm.trueCopyOptions },
                                        on: {
                                          change: function($event) {
                                            return _vm.setInputFormat()
                                          }
                                        },
                                        model: {
                                          value: _vm.step.mainFile.format,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.step.mainFile,
                                              "format",
                                              $$v
                                            )
                                          },
                                          expression: "step.mainFile.format"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.step.additionalFiles.length
                        ? _c(
                            "b-tbody",
                            _vm._l(_vm.step.additionalFiles, function(file) {
                              return _c(
                                "b-tr",
                                { key: file.id },
                                [
                                  _c("b-td", [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: "Principal",
                                            expression: "'Principal'"
                                          }
                                        ],
                                        staticClass: "d-flex align-items-center"
                                      },
                                      [
                                        _c("vs-icon", {
                                          staticClass: "mr-1",
                                          attrs: {
                                            icon: "file_present",
                                            size: "medium"
                                          }
                                        }),
                                        _vm._v(" " + _vm._s(file.name) + " ")
                                      ],
                                      1
                                    )
                                  ]),
                                  _c(
                                    "b-td",
                                    [
                                      _c("vs-input", {
                                        staticClass: "w-100",
                                        model: {
                                          value: file.currentDescription,
                                          callback: function($$v) {
                                            _vm.$set(
                                              file,
                                              "currentDescription",
                                              $$v
                                            )
                                          },
                                          expression: "file.currentDescription"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-td",
                                    [
                                      _c("b-form-select", {
                                        attrs: { options: _vm.trueCopyOptions },
                                        on: {
                                          change: function($event) {
                                            return _vm.setInputFormat()
                                          }
                                        },
                                        model: {
                                          value: file.format,
                                          callback: function($$v) {
                                            _vm.$set(file, "format", $$v)
                                          },
                                          expression: "file.format"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "b-td",
                                    { staticClass: "text-center" },
                                    [
                                      _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            size: "sm",
                                            variant: "outline-danger"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.removeAdditionalFile(
                                                file.id
                                              )
                                            }
                                          }
                                        },
                                        [_vm._v(" remover ")]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ])
          : _vm._e(),
        _c("div", { staticClass: "row" }, [
          _vm._m(6),
          _c(
            "div",
            { staticClass: "col-md-1 mt-3" },
            [
              _c(
                "vs-radio",
                {
                  attrs: {
                    "vs-name": "isPrivate",
                    "vs-value": 2,
                    "data-cy": "yes-reserved-document"
                  },
                  model: {
                    value: _vm.step.isPrivate,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "isPrivate", $$v)
                    },
                    expression: "step.isPrivate"
                  }
                },
                [_vm._v(" Si ")]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-md-1 mt-3" },
            [
              _c(
                "vs-radio",
                {
                  attrs: {
                    "vs-name": "isPrivate",
                    "vs-value": 0,
                    "data-cy": "no-reserved-document"
                  },
                  model: {
                    value: _vm.step.isPrivate,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "isPrivate", $$v)
                    },
                    expression: "step.isPrivate"
                  }
                },
                [_vm._v(" No ")]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "col-6 mt-3" },
            [
              _c("label", [_vm._v("Formato de ingreso *")]),
              _c("b-form-select", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate",
                    value: "required",
                    expression: "'required'"
                  }
                ],
                staticClass: "w-100",
                attrs: {
                  options: _vm.inputFormatOptions,
                  name: "subjectTypeDigitalDoc",
                  danger: _vm.errors.has("step-1-part-4.subjectTypeDigitalDoc"),
                  "danger-text": _vm.errors.first(
                    "step-1-part-4.subjectTypeDigitalDoc"
                  )
                },
                model: {
                  value: _vm.step.entryFormatFile,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "entryFormatFile", $$v)
                  },
                  expression: "step.entryFormatFile"
                }
              }),
              _c(
                "b-form-invalid-feedback",
                {
                  staticClass: "d-none w-100",
                  attrs: {
                    state: !_vm.errors.has(
                      "step-1-part-4.subjectTypeDigitalDoc"
                    )
                  }
                },
                [_vm._v(" Formato de ingreso es obligatorio ")]
              )
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row mb-3" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              _c("vs-input", {
                staticClass: "w-100",
                attrs: {
                  label: "Enlace a carpeta compartida",
                  name: "linktoFolder"
                },
                model: {
                  value: _vm.step.linkToFolder,
                  callback: function($$v) {
                    _vm.$set(_vm.step, "linkToFolder", $$v)
                  },
                  expression: "step.linkToFolder"
                }
              })
            ],
            1
          )
        ]),
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12 mt-3" },
            [
              _c(
                "b-form-checkbox",
                {
                  staticClass: "d-inline-block",
                  attrs: { "data-cy": "check-confirmation" },
                  model: {
                    value: _vm.step.declaration,
                    callback: function($$v) {
                      _vm.$set(_vm.step, "declaration", $$v)
                    },
                    expression: "step.declaration"
                  }
                },
                [
                  _vm._v(
                    " Declaro que los datos consignados son expresión fiel de la realidad "
                  )
                ]
              )
            ],
            1
          )
        ]),
        _vm.error.message !== ""
          ? _c(
              "div",
              {
                staticClass:
                  "con-text-validation span-text-validation-danger\n         vs-input--text-validation-span v-enter-to text-right",
                staticStyle: { height: "32px" }
              },
              [
                _c("span", { staticClass: "span-text-validation" }, [
                  _vm._v(" " + _vm._s(_vm.error.message) + " ")
                ])
              ]
            )
          : _vm._e(),
        _c("SelectDocRepository", {
          attrs: {
            "show-principal-button": "",
            "add-file": _vm.addFileRepo,
            files: _vm.step.additionalFiles,
            "remove-file": _vm.removeAdditionalFile
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v("Identificación del remitente")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12" }, [
      _c("h4", [_vm._v("Descripción del Documento")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", [_vm._v("Responsable *")]),
        _c("small", [
          _vm._v(
            " Para cambiar el destinatario, solo ingrese uno nuevo y se reemplazará el actual "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row mb-3" }, [
      _c("div", { staticClass: "col-12" }, [
        _c("h4", [_vm._v("Adjuntar Documento")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6" }, [
      _c("h5", [_vm._v("Documento principal *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-6" }, [
      _c("h5", [_vm._v("Documentos adicionales")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-4 mt-3" }, [
      _c("label", [_vm._v("Documento Reservado")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }